import React from "react";
import Svg, { Path } from "react-native-svg";

const ArrowDown = (props) => {
  const { height = 16, width = 102 } = props || {};
  return (
    <Svg
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path d="M6 6L12 0H0L6 6Z" fill="black" fill-opacity="0.8" />
    </Svg>
  );
};

export default ArrowDown;
